<div class="reveal" data-reveal modal [ngClass]="size">
    <div class="modal-container">
        <ng-content></ng-content>
    </div>
    <button class="close-modal" data-close type="button" (click)="close()">
        <i class="fa fa-times"></i>
    </button>
</div>
